import { gatewayService } from "@/_services/gateway.service";

/**
 * Fetches the previous and current month's prices for:
 * - CPO BMD (Crude Palm Oil Bursa Malaysia Derivatives)
 * - CPO Rotterdam
 * - USD/MYR (US Dollar to Malaysian Ringgit exchange rate)
 * - USD/COP (US Dollar to Colombian Peso exchange rate)
 *
 * @returns {Promise} - Returns a promise resolving with the query result.
 */
export function getColombiaCPO() {
  return gatewayService.market.colombiaFepExpo({ format: "json" });
}
